import map from 'lodash/map'
import { ProductType } from '@ztechapps/product.common'

export const productTypeOptions = map(ProductType, (item) => {
  return { label: item.label, value: item.value }
})
